import { IconButton } from "@circleco/compass/components/IconButton";
import { useShallow } from "zustand/react/shallow";

import { t } from "@/i18n-js/instance";

import { DOM_IDS } from "./Layout/defaults";
import { useCircleAIShellStore } from "./store/circleAIShellStore";

export const SidebarTriggerButton = () => {
  const { toggleLeftSidebarVisible, isLeftSidebarVisible } =
    useCircleAIShellStore(
      useShallow(s => ({
        toggleLeftSidebarVisible: s.toggleLeftSidebarVisible,
        isLeftSidebarVisible: s.isLeftSidebarVisible,
      })),
    );
  return (
    <IconButton
      icon="layout-sidebar"
      size="sm"
      variant="outline"
      onClick={toggleLeftSidebarVisible}
      title={
        isLeftSidebarVisible
          ? t("circle_ai_shell.close_sidebar")
          : t("circle_ai_shell.open_sidebar")
      }
      aria-label={
        isLeftSidebarVisible
          ? t("circle_ai_shell.close_sidebar")
          : t("circle_ai_shell.open_sidebar")
      }
      aria-expanded={isLeftSidebarVisible}
      aria-controls={DOM_IDS.communityLeftSidebarBody}
      data-testid="circle-ai-shell-sidebar-trigger"
    />
  );
};

SidebarTriggerButton.displayName = "CircleAIAppShell.SidebarTriggerButton";
